import agent from './agent';
import DateFormat from '../utils/DateFormat.js';

import config from '../../config';
import { Role } from './role.js';

import messageFactory from './MessageFactory.js';
import systemStreamer from './SystemStreamer.js';
import logService from './logService3.js';
import { jwtDecode } from 'jwt-decode';

import reconnectManager from '../ReconnectManager';

const useInMemToken = false;
const tokenKey = 'token';

let inMemUserToken;

const _name = 'AuthService';
class AuthService {
    getCurrentUser() {
        try {
            const token = this.load();
            if (this.isTokenExpired(token)) {
                console.log(`getCurrentUser: token expired`);
                return null;
            }

            const user = jwtDecode(token);
            return user;
        } catch (error) {
            console.log('Current user error ', error);
            return null;
        }
    }

    isTokenExpired = (token) => {
        if (!token) return true;

        const user = jwtDecode(token);
        var current_time = Date.now(); // / 1000;

        if (config.appMode === 'debug') {
            const expires = DateFormat.fromEpoch(user.exp * 1000);
            const current = DateFormat.fromEpoch(current_time);

            // LogService.log(`isTokenExpired: exp=${expires}, current=${current} `);
        }

        return current_time > user.exp * 1000;
    };

    initStreamer = async (token) => {
        try {
            // const token = this.getToken();
            if (token === null) {
                return;
            }

            reconnectManager.init(systemStreamer); // ADDED — bind once before first start

            // await streamerHelper.stop();
            const r = await systemStreamer.start();
            if (!r) {
                logService.log('AuthService.InitStreamer: not initialized');
            }

            const payload = messageFactory.createRequest('setToken', token);
            const msg = messageFactory.serialize(payload);
            await systemStreamer.send(msg);

            this.streamerInitialized = true;
            return this.streamerInitialized;
        } catch (error) {
            logService.logError(`${_name}.initStreamer: ${error.message}`);
        }
    };

    /**
     *
     */
    cleanup = async () => {
        try {
            await systemStreamer.stop();
        } catch (error) {
            logService.logError(`${_name}.cleanup: ${error.message}`);
        }
    };

    isConnected = () => {
        try {
            if (systemStreamer.isConnected) return true;

            return false;
        } catch (error) {
            console.log(`AuthService: ${error.message}`);
        }
    };

    getToken() {
        try {
            const token = this.load();
            return token;
        } catch (error) {
            console.log(`AuthService.getTOoken: ${error}`);

            return null;
        }
    }

    hasRole(user, roles) {
        if (user === null) return false;
        if (roles.indexOf(user.role) === -1) return false;

        return true;
    }
}

const authService = new AuthService();
export default authService;
